export default "__VITE_ASSET__BU5Y7mTB__"